import { gql, useMutation } from '@apollo/client';
import Link from 'next/dist/client/link';
import React from 'react';
import { useTranslation } from 'react-i18next';

import AuthLayout from '~/features/layouts/AuthLayout';
import Alert from '~/shared/ui/alert';
import Button from '~/shared/ui/button';
import FormActions from '~/shared/ui/form-actions';
import FormGroup from '~/shared/ui/form-group';
import Input from '~/shared/ui/input';
import { PanelTitle, PanelIntro } from '~/shared/ui/panel';

const REQUEST_PASSWORD_RESET = gql`
  mutation requestPasswordReset($email: String!) {
    requestPasswordReset(input: { email: $email })
  }
`;

const ForgotPassword = () => {
  const { t } = useTranslation('auth');

  const [requestPasswordReset, { data, called, loading, error }] = useMutation(
    REQUEST_PASSWORD_RESET,
  );
  const success = data?.requestPasswordReset;

  async function handleSubmit(e) {
    e.preventDefault();

    const variables = {
      email: e.currentTarget.email.value,
    };

    requestPasswordReset({
      variables,
    }).catch((e) => {
      // errors are handled by the useMutation hook
    });
  }

  return (
    <AuthLayout back="/" title={t('login.general.page_title')}>
      <PanelTitle>{t('login.forgot_password.title')}</PanelTitle>
      <PanelIntro>{t('login.forgot_password.intro')}</PanelIntro>
      <form onSubmit={handleSubmit}>
        {!!error && (
          <Alert type="error">{t('login.forgot_password.error')}</Alert>
        )}
        {called && success && (
          <Alert type="success">{t('login.forgot_password.success')}</Alert>
        )}
        <FormGroup
          label={t('login.general.fields.email.label')}
          id="login-username"
        >
          <Input
            type="email"
            name="email"
            required
            placeholder={t('login.general.fields.email.placeholder')}
          />
        </FormGroup>
        <FormActions>
          <Button
            type="submit"
            iconAfter="arrow-right"
            disabled={loading || (called && success)}
          >
            {t('login.forgot_password.button_request_reset')}
          </Button>
          <Link href="/login">{t('login.forgot_password.back_to_login')}</Link>
        </FormActions>
      </form>
    </AuthLayout>
  );
};

ForgotPassword.options = {
  isPublic: true,
};

export default ForgotPassword;
